import { memo, useState } from "react";

import { Mail as GetUpdatesIcon } from "@hl/base-components/lib/assets/icons.generated";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks/useFeatureFlags";
import { FeedbackModal } from "@hl/shared-features/lib/features/feedback";
import {
  QuickStartBox,
  QuickStartModal,
} from "@hl/shared-features/lib/features/quick-start";
import {
  AppShell,
  Burger,
  Container,
  Header,
  MediaQuery,
  Space,
} from "@mantine/core";
import { Outlet } from "react-router-dom";

import { ReactComponent as TokenIcon } from "assets/icons/hexagon.svg";
import { ReactComponent as LockIcon } from "assets/icons/lock-2.svg";
import { ReactComponent as PageIcon } from "assets/icons/page.svg";
import { ReactComponent as PortfolioIcon } from "assets/icons/portfolio-icon.svg";
import { ReactComponent as QuickStartIcon } from "assets/icons/quick-start-icon.svg";
import { ReactComponent as RequestFeatureIcon } from "assets/icons/request-feature.svg";
import { TOOLS_URL } from "config";
import { SideBar } from "~/components/Sidebar";
import { AppFooter } from "~/features/layout/Footer";
import GetUpdatesModal from "~/features/updates/GetUpdatesModal";

import { AppHeader } from "../../layout/Header";
import { Layout } from "../../layout/Layout";

import * as styles from "./styles";

const MainLayout = () => {
  const [quickStartModal, setQuickStartModal] = useState<boolean>(false);
  const [featureRequestModal, setFeatureRequestModal] =
    useState<boolean>(false);
  const [opened, setOpened] = useState(false);
  const [getUpdatesModalOpen, setGetUpdatesModalOpen] = useState(false);

  const enableCreatorPortfolio = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_CREATOR_PORTFOLIO
  );
  const enableNewCreate = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_INHOTIM_NEW_COLLECTION_UX
  );

  const data = [
    {
      link: TOOLS_URL.gates.list,
      label: "Gates",
      icon: <LockIcon />,
    },
    {
      link: TOOLS_URL.pages.list,
      label: "Pages",
      icon: <PageIcon />,
    },
  ];

  if (enableCreatorPortfolio) {
    data.unshift({
      link: TOOLS_URL.portfolio.home,
      label: "Portfolio",
      icon: <PortfolioIcon />,
    });
  }
  data.unshift({
    link: TOOLS_URL.home,
    label: enableNewCreate ? "Collections" : "Tokens",
    icon: <TokenIcon />,
  });

  const showQuickStartModal = () => {
    setQuickStartModal(true);
  };

  const showFeatureRequestModal = () => {
    setFeatureRequestModal(true);
  };

  const menuButtons = [
    {
      onClick: showQuickStartModal,
      label: "Quick start guide",
      icon: <QuickStartIcon />,
    },
    {
      onClick: showFeatureRequestModal,
      label: "Request a feature",
      icon: <RequestFeatureIcon />,
    },
    {
      onClick: () => setGetUpdatesModalOpen(true),
      label: "Get updates",
      icon: <GetUpdatesIcon />,
    },
  ];

  return (
    <AppShell
      padding="md"
      navbar={<SideBar hidden={!opened} items={data} buttons={menuButtons} />}
      header={
        <Header height={56} withBorder={false}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <MediaQuery largerThan="sm" styles={{ display: "none" }}>
              <Burger
                opened={opened}
                onClick={() => setOpened((o) => !o)}
                size="sm"
                mr="xl"
              />
            </MediaQuery>
            <AppHeader isDashboard />
          </div>
        </Header>
      }
      footer={<AppFooter />}
    >
      <Layout css={styles.layout2} showHeader={false} showFooter={false}>
        <Outlet />
        <Space h={40} />
        <Container size="sm" px="sm">
          <QuickStartBox />
          <QuickStartModal
            isOpen={quickStartModal}
            onClose={() => setQuickStartModal(false)}
          />
          <FeedbackModal
            isOpen={featureRequestModal}
            onClose={() => setFeatureRequestModal(false)}
          />
          <GetUpdatesModal
            open={getUpdatesModalOpen}
            onClose={() => setGetUpdatesModalOpen(false)}
          />
        </Container>
      </Layout>
    </AppShell>
  );
};

export default memo(MainLayout);
